import { styled } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[6]};
  margin-top: ${({ theme }) => theme.spacing[2]};
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]};
  padding-bottom: ${({ theme }) => theme.spacing[6]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.weak};

  &:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const SectionTitle = styled.div`
  font-size: ${({ theme }) => theme.fonts.medium.fontSize};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary.color};
`;

export const SectionDescription = styled.div`
  font-size: ${({ theme }) => theme.fonts.sm.fontSize};
  color: ${({ theme }) => theme.colors.text.secondary.color};
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]};
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 400px minmax(0, 400px);
  align-items: center;
  gap: ${({ theme }) => theme.spacing[7]};

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing[1]};
  }
`;

export const RowLabel = styled.div`
  font-size: ${({ theme }) => theme.fonts.medium.fontSize};
  color: ${({ theme }) => theme.colors.text.secondary.color};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const LoaderWrapper = styled.div`
  min-height: 300px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
